module.exports = __webpack_public_path__ + "img/D.601628e1.png";